export interface CostAccountingArray {
  id: number;
  projectNumber: string;
  projectName: string;
  startDate: string;
  endDate: string;
  totalCost: string;
  mahHoursCost: string;
  dairenSubcontractingCost: string;
  otherSubcontractingCost: string;
  expenses: string;
  manHoursTotal: string;
}

export interface CostAccountingTotalArray {
  totalTotalCost: string;
  totalMahHoursCost: string;
  totalDairenSubcontractingCost: string;
  totalOtherSubcontractingCost: string;
  totalExpenses: string;
  totalManHours: string;
}

export type CostAccountingGetResponse = {
  items: CostAccountingArray[];
  totalItems: CostAccountingTotalArray;
  page: number;
  totalPages: number;
};

export const EmptyCostAccountingGetResponse: CostAccountingGetResponse = {
  items: [],
  totalItems: {
    totalTotalCost: '0',
    totalMahHoursCost: '0',
    totalDairenSubcontractingCost: '0',
    totalOtherSubcontractingCost: '0',
    totalExpenses: '0',
    totalManHours: '0',
  },
  page: 1,
  totalPages: 0,
};
